import { BaseModel } from '@tcc-mono/shared/data-access';
import { Animal } from './animal.model';
import { SlaughterListLine } from './slaughter-list.model';

export class Koppel extends BaseModel {
  id: number;
  number: string;
  stable_id: number;
  animal_count: number;
  avg_start_weight: number;
  slaughter_stats: any;
}

export interface KoppelAnimal extends BaseModel {
  id: number
  country_code: string
  identification_number: string
  work_number: string
  setup_code: any
  setup_code_id: any
  origin_ubn: string
  date_of_birth: string
  arrival_date: string
  gender_id: number
  gender_code: string
  gender_name: string
  color_id: number
  color_code: string
  color_name: string
  start_weight: string
  remarks: any
  age: number
  days_on_stable: number
  weight_diff: string
  weight_per_day: string
  purchase_price: string
  purchase_price_ex_vat: string
  health_registrations: number
  injection_sum: number;
  warranty_till: string;
  slaughter_list_line: SlaughterListLine
}


